import { render, staticRenderFns } from "./ProjectTimeline.vue?vue&type=template&id=1818b7c2"
import script from "./ProjectTimeline.vue?vue&type=script&lang=js"
export * from "./ProjectTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports